export default {
    _default: (field) => `Полето ${field} е с невалидна стойност.`,
    _invalid_format: (field, {format}) => `The field must be in the format ${format}.`,
    _atLeastOneRule: (field) => ` TODO `,
    equals: (field) => `Полето ${field} TODO .`,
    alphadash: (field) => `Полето ${field} може да съдържа буквено-цифрови знаци, както и тирета и долни черти.`,
    alphanumeric: (field) => `Полето ${field} може да съдържа само буквено-цифрови символи.`,
    alphaspaces: (field) => `Полето ${field} може да съдържа само азбучни знаци, както и интервали.`,
    alpha: (field) => `Полето ${field} може да съдържа само азбучни знаци.`,
    between: (field, {from, to}) => `Полето ${field} може да е между ${from} и ${to}.`,
    decimal: (field, {decimals = '*'} = {}) => `Полето ${field} трябва да е числено ${!decimals || decimals === '*' ? '' : 'и може да съдържа ${decimals} знака'}`,
    digits: (field, {length}) => `Полето ${field} трябва да е цифрово и да съдържа точно ${length} цифри.`,
    email: (field) => `Полето ${field} трябва да е коректен Email адрес.`,
    in: (field) => `Полето ${field} трябва да е валидна стойност.`,
    integer: (field) => `Полето ${field} трябва да е цяло число.`,
    ip: (field) => `Полето ${field} трябва да е валиден IP адрес.`,
    maxlength: (field, {value}) => `Полето ${field} не може да бъде по-голямо от ${value} знака.`,
    max: (field, {max}) => `Полето ${field} трябва да бъде ${max} или по-малко.`,
    minlength: (field, {value}) => `Полето ${field} трябва да съдържа минимум ${value} символа.`,
    min: (field, {min}) => `Полето ${field} трябва да бъде минимум ${min} или повече.`,
    numeric: (field) => `Полето ${field} може да съдържа само цифри.`,
    match: (field) => `Полето ${field} съдържа невалиден формат.`,
    required: (field) => `Полето ${field} е задължително.`,
    url: (field) => `Полето ${field} не съдържа валиден URL адрес.`,
    date: (field, {format}) => `The ${field} must be in the format ${format}.`,
    time: (field) => `The ${field} must be in the format HH:mm:ss.`,
    datetime: (field, {format}) => `The ${field} must be in the format ${format}.`,
    before: (field, {target, inclusion, format}) => `The ${field} must be before ${inclusion ? 'or equal to ' : ''}${target}.`,
    after: (field, {target, inclusion, format}) => `The ${field} must be after ${inclusion ? 'or equal to ' : ''}${target}.`,
    dateBetween: (field, {min, max}) => `The ${field} must be between ${min} and ${max}.`
};
